
import React from "react";
import "../../../styles/widgets/widgets.css";
import "../../../styles/groups/attraction.css";
import { LocationSelector } from "../form";

/**
 * 
 * @param {{ id, name, category, lgu }} attraction 
 * @param {{ lgu }} defaults 
 * @param {{ lgu, province }} collection 
 */
export function AttractionFactory({ attraction, defaults, collection, onChange, lguFixed }) {
    attraction = attraction ? { ...attraction } : { name: "", category: "", lgu: defaults.lgu };

    const { name, category } = attraction;
    const refs = {
        name: React.createRef(),
        category: React.createRef()
    };

    const update = () => {
        onChange({ 
            name: refs.name.current?.value || "", 
            category: refs.category.current?.value || "",
            lgu: attraction.lgu
        });
    };

    return <div className="attraction-factory">
        <div className="upper">
            <div className="upper-left">
                <div className="field">
                    <label>TOURIST ATTRACTION NAME</label>
                    <input autoFocus onInput={() => update()} className="input" ref={refs.name} defaultValue={name} />
                </div>
            </div>
            
            <div className="upper-right">
                <div className="field">
                    <label>CATEGORY</label>
                    <input onInput={() => update()} className="input" ref={refs.category} defaultValue={category} />
                </div>
            </div>
        </div>
        { !lguFixed ? <div className="lower">
            <div className="field">
                <label>LOCATION</label>
                <LocationSelector values={{ lgu: attraction.lgu }} collection={collection} onChange={({lgu}) => { attraction.lgu = lgu; update() }} />
            </div>
        </div> : ""
        }
        
    </div>
}